<template>
    <div class="location">
        <input v-bind:class="[ address.address == '' ? '' : 'hide' ]" id="galoc" type="text" />

        <input type="hidden" v-for="(value,index) in address" v-if="index != 'address_2'" v-bind:name="name + '[' + index + ']'" v-bind:value="value" />

        <div class="detail" v-if="address.address != ''">
            <div class="flex-center">
                <div>
                    <div v-html="address.address" class="address"></div>
                    <div>
                        <span class="city" v-html="address.city"></span>,
                        <span class="state" v-html="address.state"></span>
                        <span class="zip" v-html="address.zip"></span>
                    </div>
                </div>
                <div class="flex-filler"></div>
                <div>
                    <a @click.prevent="reset" href=""><span class="material-icons">highlight_off</span></a>
                </div>
            </div>
        </div>
        <div class="address_2" v-bind:class="[ address.address == '' ? 'hide' : '' ]">
            <input type="text" v-bind:name="name + '[address_2]'" v-bind:value="address.address_2" placeholder="Unit, Apt. #, etc." />
        </div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            if(this.location != undefined) {
                var e = this;
                $.each(e.location,function(index,value) {
                    if(e.address[index] != undefined) {
                        e.address[index] = value;
                    }
                });
            }
        },
        data:function() {
            return {
                autocomplete:false,
                mapID:'galoc',
                types:['geocode'],
                address: {
                    address : '',
                    address_2 : '',
                    city : '',
                    state : '',
                    zip : '',
                    lat:'',
                    lng:'',
                },
                componentForm : {
                    street_number: 'short_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'short_name',
                    postal_code: 'short_name'
                },
                componentField: {
                    street_number:'address',
                    route:'address',
                    locality:'city',
                    administrative_area_level_1:'state',
                    postal_code:'zip'
                }
            }
        },
        props:{
            name:{ type:String,default:'location'},
            location: { type:Object }
        },
        methods: {
            processAddress:function() {
                var place = this.autocomplete.getPlace();
                var map = this;
                map.address.lat = place.geometry.location.lat();
                map.address.lng = place.geometry.location.lng();
                var addressNumber;
                for (var i = 0; i < place.address_components.length; i++) {
                    var addressType = place.address_components[i].types[0];
                    var inputName;
                    if (map.componentForm[addressType]) {
                        var val = place.address_components[i][map.componentForm[addressType]];
                        inputName = map.componentField[addressType];
                        if(addressType == 'street_number') {
                            addressNumber = val;
                        } else if(addressType == 'route') {
                            val = addressNumber+' '+val;
                        }
                        if(addressType != 'street_number') {
                            map.address[inputName] = val;
                        }
                    }
                }
                if(!addressNumber) {
                    map.address['address'] = place.name;
                }
                setTimeout(function() {
                    map.$setModalItemHeight();
                },100);
            },
            reset:function() {
                $('#'+this.mapID).val('');
                var map = this;
                map.address = {
                    address : '',
                    city : '',
                    state : '',
                    zip : '',
                    latitude:'',
                    longitude:''
                };
                setTimeout(function() {
                    map.$setModalItemHeight();
                    $('#'+map.mapID).focus();
                },100);
            }
        },
        mounted:function() {
            var e = this;
            this.autocomplete = new google.maps.places.Autocomplete(
                document.getElementById(e.mapID),
                {types: e.types}
            )
            this.autocomplete.addListener('place_changed', e.processAddress);
        }
    }
</script>

